<script setup>
import {formatNumber} from "@/helpers/string";
import useMarkdown from "@/composables/useMarkdown";

defineProps(['startup']);

const md = useMarkdown();

function formateDateForNews(string) {
    const date = new Date(string);

    return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}
</script>

<template>
    <div class="modal-matchmaking__content__inner">
        <div class="modal-matchmaking__content__details">
            <ul class="matchmaking__overview">
                <li class="matchmaking__overview__name">
                    <a href="#">{{startup.website }}</a>
                </li>
                <li v-if="startup.total_raised" class="matchmaking__overview__funding">
                    {{ formatNumber(startup.total_raised) }} Raised
                </li>
                <li v-if="startup.revenue_range" class="matchmaking__overview__income">
                    {{ startup.revenue_range }} Annual Income
                </li>
                <li v-if="startup.employees" class="matchmaking__overview__employees">
                    {{ startup.employees }} Employees
                </li>
                <li v-if="startup.location" class="matchmaking__overview__location">
                    {{ startup.location }}
                </li>
                <li v-if="startup.stage" class="matchmaking__overview__startups">
                    {{ startup.stage }}
                </li>
                <li v-if="startup.founded" class="matchmaking__overview__founded">Founded
                    {{ startup.founded }}
                </li>
            </ul>

            <div class="matchmaking__about">
                <h5 class="heading5 heading5--secondary mb-4">About {{startup.name}}:</h5>

                <p>{{ startup.description }}</p>

                <slot name="addSection"/>
            </div>
        </div>

        <div v-if="startup.features?.length" class="card-headline">
            <header class="card-headline__header">Features</header>

            <div class="card-headline__content">
                <div v-html="md.render(startup.features)"/>
            </div>
        </div>

        <div v-if="startup.news.length" class="card-headline">
            <header class="card-headline__header">News</header>

            <div class="card-headline__content">
                <div
                    v-for="news in startup.news"
                    :key="news.id"
                    class="card card--bordered"
                >
                    <div>
                        <a :href="`https://${news.domain}`" class="card-headline__url" target="_blank">{{ news.domain }}</a>

                        <h6 class="heading6">
                            <a :href="news.url" target="_blank">{{ news.title }}</a>
                        </h6>

                        <time v-if="news.posted_on" class="card-headline__time">
                            {{formateDateForNews(news.posted_on) }}
                        </time>
                    </div>

                    <figure v-if="news.image_url" class="card-headline__img">
                        <img :src="news.image_url" style="height: 100%" alt="">
                    </figure>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
